export const BaseCommonTypeProduct = `
  regularPrice
  salePrice
  price
  onSale
`;
